module.exports = __webpack_public_path__ + "img/product2.28b76c41.png";